import type { TransportAirlineApiContext } from "../../../../common/utils/transport/airlineTransportContext";

export type ObbResolvedApiPaths =
  | { kind: "invalid_airline" }
  | {
      kind: "ok";
      infoPath: string;
      stationsSearchUrl: (apiUrl: string, query: string) => string;
      prebookPath: string;
      bookingsPath: string;
      /** Hotel estimation POST path (v2). */
      estimationV2Path: string;
      /** Airline estimation POST path builder (uppercase provider segment). */
      estimationAirlinePath: (iataCode: string) => string;
    };

function getAirportObbTransportsBasePath(iataCode: string): string {
  return `v1/airports/${encodeURIComponent(iataCode)}/transports/obb`;
}

function getAirportBookingsPath(iataCode: string): string {
  return `v1/airports/${encodeURIComponent(iataCode)}/bookings`;
}

/**
 * Resolves ÖBB API paths for hotel and airline contexts.
 * Mirrors SBB path shape.
 */
export function resolveObbApiPaths(transportContext: TransportAirlineApiContext): ObbResolvedApiPaths {
  if (transportContext.mode === "airline_missing_iata") {
    return { kind: "invalid_airline" };
  }

  if (transportContext.mode === "airline") {
    const base = getAirportObbTransportsBasePath(transportContext.iataCode);
    return {
      kind: "ok",
      infoPath: base,
      stationsSearchUrl: (apiUrl, query) => `${apiUrl}/${base}/stations?stationName=${encodeURIComponent(query)}`,
      prebookPath: `${base}/prebook`,
      bookingsPath: getAirportBookingsPath(transportContext.iataCode),
      estimationV2Path: "v2/transport/obb",
      estimationAirlinePath: iataCode => `v1/airports/${encodeURIComponent(iataCode)}/transports/OBB`
    };
  }

  return {
    kind: "ok",
    infoPath: "transport/obb",
    stationsSearchUrl: (apiUrl, query) => `${apiUrl}/transport/obb/stations?stationName=${encodeURIComponent(query)}`,
    prebookPath: "transport/obb/prebook",
    bookingsPath: "bookings",
    estimationV2Path: "v2/transport/obb",
    estimationAirlinePath: iataCode => `v1/airports/${encodeURIComponent(iataCode)}/transports/OBB`
  };
}
